import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import { isFieldForListingType } from '../../util/fieldHelpers';

import { Heading } from '../../components';
import GradingInfo from '../../components/GradingInfo/GradingInfo';
import ContentModal from '../../components/ContentModal/ContentModal';

import css from './ListingPage.module.css';
import classNames from 'classnames';

const SectionDetailsMaybe = props => {
  const { publicData, metadata = {}, listingFieldConfigs, isFieldForCategory, intl,propsForCustomFields } = props;

  if (!publicData || !listingFieldConfigs) {
    return null;
  }

  const pickListingFields = (filteredConfigs, config) => {
    const { key, schemaType, enumOptions, showConfig = {} } = config;
    const listingType = publicData.listingType;
    const isTargetListingType = isFieldForListingType(listingType, config);
    const isTargetCategory = isFieldForCategory(config);

    const { isDetail, label } = showConfig;
    const publicDataValue = publicData[key];
    const metadataValue = metadata[key];
    const value = typeof publicDataValue != null ? publicDataValue : metadataValue;

    if (isDetail && isTargetListingType && isTargetCategory && typeof value !== 'undefined') {
      const findSelectedOption = enumValue => enumOptions?.find(o => enumValue === `${o.option}`);
      const getBooleanMessage = value =>
        value
          ? intl.formatMessage({ id: 'SearchPage.detailYes' })
          : intl.formatMessage({ id: 'SearchPage.detailNo' });
      const optionConfig = findSelectedOption(value);

      const isCustomDimension = key === 'dimensions' && value === 'custom-size';
      const customDimensionValue = publicData?.custom_dimensions || metadata?.custom_dimensions;
      
      const finalValue = isCustomDimension && customDimensionValue ? customDimensionValue : optionConfig?.option;
      const finalValueLabel = isCustomDimension && customDimensionValue ? customDimensionValue : optionConfig?.label;

      const customDimensionDescription = publicData?.custom_dimensions_description || metadata?.custom_dimensions_description;

      return schemaType === 'enum'
        ? filteredConfigs.concat({
            key,
            schemaType,
            value: finalValue,
            valueLabel: finalValueLabel,
            label,
            isCustom: isCustomDimension,
            description: isCustomDimension ? customDimensionDescription : undefined,
          })
        : schemaType === 'boolean'
        ? filteredConfigs.concat({ key, schemaType, value: getBooleanMessage(value), label })
        : schemaType === 'long'
        ? filteredConfigs.concat({ key, schemaType, value, label })
        : filteredConfigs;
    }
    return filteredConfigs;
  };

  const existingListingFields = listingFieldConfigs.reduce(pickListingFields, []);
   const filteredPropsForCustomFields = propsForCustomFields.filter(
    field => field.key !== 'genre'
  );
  const mergedListingFields = [...existingListingFields, ...filteredPropsForCustomFields];
 return mergedListingFields.length > 0 ? (
    <section className={css.sectionDetails}>
      <Heading as="h2" rootClassName={classNames(css.sectionHeading,css.detailHeading)}>
        <FormattedMessage id="ListingPage.detailsTitle" />
      </Heading>
      <ul className={css.details}>
        {Array.isArray(mergedListingFields) &&
          mergedListingFields.map(detail => {
            const formattedLabel = intl.formatMessage({
              id: `ListingPage.field.${detail.key}.label`,
              defaultMessage: detail.label,
            });
            const formattedValue =
              detail.schemaType === 'enum'
                ? intl.formatMessage({
                  id: `ListingPage.field.${detail.key}.option.${detail.value}`,
                  defaultMessage: detail.valueLabel || detail.value,
                })
                : detail.schemaType === 'text' || detail.schemaType === 'shortText' ?
                  detail.text
                  : detail.value;

            // Show info icon for vinyl/sleeve condition and dimensions
            const isCustomDimensionField = detail.key === 'dimensions' && detail.isCustom;
            const showInfoIcon = detail.key === 'vinyl_condition' || detail.key === 'sleeve_condition' || detail.key === 'dimensions';

            return (
          <li key={detail.key} className={css.detailsRow}>
            <span className={css.detailLabel}>
              {formattedLabel}
              {isCustomDimensionField && detail.description ? (
                <ContentModal
                  title={formattedValue}
                  description={detail.description}
                />
              ) : showInfoIcon ? (
                <GradingInfo
                  type={detail.key === 'dimensions' ? 'dimensions' : 'grading'}
                  hideCustomGenericOption={detail.key === 'dimensions'}
                />
              ) : null}
            </span>
            <span className={css.detailValue}>
               {formattedValue}
            </span>
          </li>
        );
          })}
      </ul>
    </section>
  ) : null;
};

export default SectionDetailsMaybe;
